export class SchoolNaam {
  constructor(public schoolNr: string, public schoolNaam: string ) { }
}